<template>
    <div>
      <b-tabs
        content-class="mt-3"
        active-nav-item-class="font-weight-bold border-left-0 border-top-0 border-right-0 border-bottom border-success"
        small
        fill
      >
        <b-tab active>
          <template #title>
            <span class="text-secondary">Installment / Advanced Payment</span>
          </template>
          <installment
            :form="form"
            :is-view="isView"
            :is-edit="isEdit"
          />
        </b-tab>
        <b-tab>
          <template #title>
            <span class="text-secondary">Explosive</span>
          </template>
          <explosive
            :form="form"
            :is-view="isView"
            :is-edit="isEdit"
            :other-rate="otherRate"
            :fuel-price="fuelPrice"
            :contractor="contractor"
            @update="update"
          />
        </b-tab>
        <b-tab>
          <template #title>
            <span class="text-secondary">Other Deduction</span>
          </template>
          <other-deduction
            :form="form"
            :is-view="isView"
            :is-edit="isEdit"
          />
        </b-tab>
      </b-tabs>
    </div>
</template>

<script>
import Installment from './deduction/ComponentInstallment'
import Explosive from './deduction/ComponentExplosive'
import OtherDeduction from './deduction/ComponentOtherDeduction'

export default {
  props: {
    isView: {
      types: Boolean,
      default: false
    },
    isEdit: {
      types: Boolean,
      default: false
    },
    form: {
      types: Object,
      default: () => {}
    },
    otherRate: {
      types: Array,
      default: () => {}
    },
    fuelPrice: {
      types: Object,
      default: () => {}
    },
    contractor: {
      types: Object,
      default: () => {}
    }
  },

  components: {
    Installment,
    Explosive,
    OtherDeduction
  },

  data: () => ({

  }),

  computed: {

  },

  mounted() {},

  methods: {
    update(value) {
      this.$emit('update', value)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
